var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",style:({color: _vm.color})},[_c('h4',[_vm._v(_vm._s(_vm.title)+" "),(_vm.required)?_c('span',{staticClass:"required-asterisk"},[_vm._v("*")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }